<template>
  <div>
    <Loading v-if="loading" />

    <v-sheet
      v-else-if="item.title"
      color="#FAFAFA"
      class="py-10 py-sm-12 py-md-14 py-lg-16"
    >
      <v-container>
        <PagesTitle logoHeight="24px" :mod="mod">{{ item.title }}</PagesTitle>

        <div class="align-center mt-10 grid-list">
          <img
            v-if="item.img"
            :src="files + item.img"
            :alt="item.title"
            class="d-block item-img"
          />

          <div class="item-text">
            <div
              v-if="item.intro || item.text"
              class="secondary--text text--lighten-3 text-center text-sm-start"
              v-html="item.intro || item.text"
            ></div>

            <div
              v-if="item.intro && item.text"
              class="d-flex justify-center mt-3"
            >
              <v-btn
                class="text-none"
                rounded
                color="primary"
                dark
                depressed
                @click="dialog = true"
              >
                Saiba mais
              </v-btn>
            </div>
          </div>

          <v-dialog v-model="dialog" width="800">
            <v-card class="px-5 pt-10 pb-5">
              <div
                class="secondary--text text--lighten-3"
                v-html="item.text"
              ></div>
            </v-card>
            <v-btn
              icon
              class="dialog-btn"
              color="primary"
              text
              @click="dialog = false"
            >
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-dialog>
        </div>
      </v-container>
    </v-sheet>
  </div>
</template>

<script>
import Loading from "../widgets/Loading.vue";
import PagesTitle from "../widgets/PagesTitle.vue";

const _config = {
  mod: "pages-structure",
};

export default {
  props: {
    mod: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    item: {},
    dialog: false,
  }),
  mounted() {
    this.$rest(_config.mod)
      .get({
        id: this.mod,
        save: (state, data) => (this.item = data),
      })
      .then(() => (this.loading = false));
  },
  components: {
    Loading,
    PagesTitle,
  },
};
</script>

<style>
.v-dialog {
  position: relative !important;
}
.v-dialog {
  scrollbar-width: auto;
  scrollbar-color: var(--v-primary-base) #ffffff;
}

.v-dialog::-webkit-scrollbar {
  width: 7px;
}
.v-dialog::-webkit-scrollbar-track {
  background: #ffffff;
}

.v-dialog::-webkit-scrollbar-thumb {
  background-color: var(--v-primary-base);
  border-radius: 10px;
}
</style>
<style lang="scss" scoped>
.dialog-btn {
  position: absolute;
  top: 0;
  right: 0;
}
.grid-list {
  display: grid;
  gap: 42px;
  grid-template-columns: 1fr 1fr;
  .item-img {
    border-radius: 18px;
    width: 100%;
  }
  @media screen and (max-width: 1264px) {
    gap: 20px;
  }
  @media screen and (max-width: 960px) {
    gap: 30px;
    grid-template-columns: 1fr;
  }
}
</style>
